export default __webpack_public_path__ + "static/media/p2p.f594175e.webp";